import { useNavigate } from 'react-router-dom';

import { usePopup } from 'hooks/usePopup';
import { PurchaseDto } from 'services/order/orderService.dto';

import BuyerReassignmentPopup from './BuyerReassignmentPopup';

interface Props {
  purchase: PurchaseDto;
  onConfirmed: () => void;
}

export const useBuyerReassignmentPopup = () => {
  const { showPopup, hidePopup } = usePopup();
  const navigate = useNavigate();

  const onCanceled = () => {
    hidePopup();
    navigate('/');
  };

  const showBuyerReassignmentPopup = ({ onConfirmed, purchase }: Props) => {
    showPopup(
      <BuyerReassignmentPopup
        purchase={purchase}
        onConfirmed={() => {
          onConfirmed();
          hidePopup();
        }}
        onCanceled={onCanceled}
      />,
      { onClose: onCanceled, hasBlur: true }
    );
  };

  return { showBuyerReassignmentPopup };
};
